<template>
    <div>
        <vue-headful :title="'Agencies ('+agencyCount+') - WTS'" />

        <h4 class="page-header">
            Agencies ({{ agencyCount }})

            <router-link to="/agencies/create" class="btn btn-sm btn-info" v-if="canManageAgencies">
                <i class="fas fa-plus-square"></i> Create
            </router-link>
        </h4>

        <div class="card">
            <div class="card-body">
                <v-server-table ref="agenciesTable" url="/agencies" :columns="columns" :options="options">

                    <div slot="beforeFilter" style="display: inline-block; margin-right: 5px;">

                    </div>

                    <div slot="afterFilter" class="ml-2">
                        <button class="btn btn-sm btn-default" v-on:click="clearFilters()" title="Clear All Filters">
                            <i class="fas fa-ban"></i>
                        </button>
                        <button class="btn btn-sm btn-default" v-on:click="showFilters = !showFilters" title="Apply Filters">
                            <i class="fas fa-filter"></i>
                            <span class="badge badge-danger" v-if="filterCount > 0">{{ filterCount }}</span>
                        </button>
                        <button type="button" class="btn btn-sm btn-default" v-on:click="exportTable()" :disabled="exportingTable">
                            <template v-if="!exportingTable"><i class="fa fa-file-excel"></i> Export</template>
                            <template v-else><i class="fa fa-spinner fa-spin"></i> Exporting</template>
                        </button>
                    </div>

                    <template slot="id" slot-scope="props">

                    </template>

                    <template slot="agency_name" slot-scope="props">
                        <router-link :to="`/agencies/view/${props.row.id}`">{{ props.row.agency_name }}</router-link>
                    </template>

                    <template slot="address" slot-scope="props">
                        {{ props.row.address }}<span v-if="props.row.city">, {{ props.row.city }}</span> <span :title="props.row.state_name" v-if="props.row.state_code">{{ props.row.state_code }}</span>
                    </template>

                    <template slot="is_active" slot-scope="props">
                        <label class="badge badge-success" v-if="props.row.is_active == 1">Active</label>
                        <label class="badge badge-warning" v-else>Inactive</label>
                    </template>
                </v-server-table>
            </div>
        </div>

        <b-modal v-model="showFilters" :ref="'agencyListFilters'" title="Agency Filters" size="lg" no-fade ok-title="Apply Filters" @ok="applyFilters()">
            <div class="row mb-3">
                <div class="col-md-3 col-12 md-md-0 mb-2 text-md-right text-muted">Active:</div>
                <div class="col-md-7 col-12">
                    <b-form-radio-group v-model="filters['agencies.is_active']" :options="activeOptions" plain></b-form-radio-group>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                exportingTable: false,
                agencyCount: null,
                showFilters: false,
                columns: ['agency_name', 'npn', 'phone', 'email', 'address', 'city', 'address_state_name', 'zip', 'is_active'],
                options: {
                    headings: {
                        agency_name: 'Agency',
                        npn: 'NPN',
                        phone: 'Phone',
                        address: 'Address',
                        city: 'City',
                        address_state_name: 'State',
                        zip: 'Zip',
                        is_active: 'Active',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'agencies.agency_name',
                    },
                    texts:{
                        filterPlaceholder:"Search Agencies",
                    },
                    responseAdapter: (response) => {
                        //Set the count
                        this.agencyCount = response.data.count;

                        //Send it
                        return response.data;
                    },
                    requestAdapter: (data) => {
                        //Add the type
                        data.filters = this.filters;

                        //Send it
                        return data;
                    },
                    uniqueKey: 'id',
                },

                filters: {
                    'agencies.is_active': 1,
                },

                activeOptions: [
                  { text: 'All', value: null },
                  { text: 'Active Only', value: 1 },
                  { text: 'Inactive Only', value: 0 },
                ],
            }
        },

        watch: {

        },

        computed: {

            canManageAgencies(){
                //Check Permissions
                return this.$root.hasPermission("agencies.manage");
            },

            filterCount(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]) && this.filters[keys[i]].length > 0)
                    {
                        count++;
                    }
                    else if(this.filters[keys[i]] != null && this.filters[keys[i]] != '')
                    {
                        count++;
                    }
                }

                //Send it
                return count;
            },
        },

        methods: {
            clearFilters(){
                //Get the keys
                var keys = Object.keys(this.filters);
                var count = 0;

                //Loop
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    //Check the value
                    if(Array.isArray(this.filters[keys[i]]))
                    {
                        this.filters[keys[i]] = [];
                    }
                    else
                    {
                        this.filters[keys[i]] = null;
                    }
                }

                //Refresh
                this.$refs.agentsTable.refresh();
            },

            applyFilters(){
                //Apply the filters
                this.$refs.agenciesTable.refresh();
            },

            exportTable(){
                //Loading indicator
                this.exportingTable = true;

                //Build the Filters
                //var filters = filterExtractor.extractFilters(this.filters);

                //Setup Columns
                var cols = JSON.parse(JSON.stringify(this.$refs.agenciesTable.columns));

                //Build the payload
                var payload = {
                    filters: this.filters,
                    query: (this.$refs.agenciesTable.getRequestParams()).query,
                    orderBy: this.$refs.agenciesTable.options.orderBy.column,
                    ascending: this.$refs.agenciesTable.options.orderBy.ascending,
                    table: 'agenciesTable',
                    columns: cols,
                    export: true,
                };

                //Send it
                this.$http.get('/agencies', payload)
                    .then(response => {
                        //Open the new window to Download the File
                        if(response.data.queued)
                        {
                            //Alert the User
                            this.$toastr.s(response.data.message);
                        }
                        else
                        {
                            //Open the download URL
                            window.open(response.data.url);
                        }
                    })
                    .catch(err => {
                        //Alert the user
                        this.$toastr.e(JSON.stringify(err), 'Failed to Export');
                    })
                    .then(response => {
                        //reset
                        this.exportingTable = false;
                    });
            },
        },

        mounted() {
            //Focus on the SEarch Input
            this.$refs.agenciesTable.$refs.genericFilter.focus();
        }
    }
</script>
